import moment, { Moment } from 'moment';
import { getSunrise, getSunset } from 'sunrise-sunset-js';

export const parameterSettings = {
  main: {
    layers: 'taubenmain',
    icon: 'dove',
    name: 'pigeonIndex',
  },
  Td: {
    layers: 'taubendewpoint',
    icon: 'dewpoint',
    name: 'humidityIndex',
  },
  wwM: {
    layers: 'taubenvis',
    icon: 'binoculars',
    name: 'fogIndex',
  },
  Nl: {
    layers: 'taubencloudlow',
    icon: 'cloud-download-alt',
    name: 'lowCloudIndex',
  },
  Nh: {
    layers: 'taubencloudhigh',
    icon: 'cloud-arrow-up',
    name: 'highCloudIndex',
  },
  Neff: {
    layers: 'taubencloudcover',
    icon: 'clouds',
    name: 'effCloudIndex',
  },
  TTT: {
    layers: 'taubentemp',
    icon: 'thermometer-half',
    name: 'coldIndex|heatIndex',
  },
  FF: {
    layers: 'taubenwind',
    icon: 'wind',
    name: 'windIndex',
  },
  inv: {
    layers: 'taubeninversion',
    icon: 'layer-group',
    name: 'inversionIndex',
  },
  N10: {
    layers: 'taubenfog',
    icon: 'grip-lines',
    name: 'fogIndex',
  },
  RR1: {
    layers: 'taubenprecipitation',
    icon: 'cloud-showers-heavy',
    name: 'precipitationIndex',
  },
  HvTI1: {
    layers: 'taubenthunderstorm',
    icon: 'thunderstorm',
    name: 'thunderIndex',
  },
};

// NOT USED ANYMORE
export const pigeonRoutes = [
  { id: 'route1', name: 'R01 Ruffec - Nordhausen', stations: [7420, 104863] },
  {
    id: 'route2',
    name: 'R02 Vivonne - Freiburg/Elbe',
    stations: [7330, 103400],
  },
  { id: 'route3', name: 'R03 Antwerpen - Warschau', stations: [6450, 12375] },
  { id: 'route16', name: 'R04a Wien - Emmen', stations: [11034, 100106] },
  { id: 'route4', name: 'R04b Wien - Kleve', stations: [11034, 103547] },
  {
    id: 'route5',
    name: 'R05 Chalon-sur-Saône - Oldenburg',
    stations: [104308, 10215],
  },
  { id: 'route6', name: 'R06a Warschau - Heide', stations: [12375, 100378] },
  { id: 'route24', name: 'R06b Warschau - Heide', stations: [12375, 100378] },
  { id: 'route7', name: 'R07 Canapeville - Bayreuth', stations: [7038, 10677] },
  { id: 'route8', name: 'R08 Brüssel - München', stations: [6416, 101556] },
  {
    id: 'route9',
    name: 'R09 Heidenheim - Flensburg',
    stations: [104727, 100355],
  },
  { id: 'route10', name: 'R10 Antwerpen - Görlitz', stations: [6450, 10499] },
  {
    id: 'route11',
    name: 'R11 Angoulême - Memmingen',
    stations: [7420, 101595],
  },
  { id: 'route12', name: 'R12 Paderborn - Gien', stations: [10430, 7257] },
  { id: 'route13', name: 'R13 Würzburg - Brive', stations: [101333, 7412] },
  {
    id: 'route14',
    name: 'R14 Bremen - Weil am Rhein',
    stations: [100522, 101759],
  },
  {
    id: 'route15',
    name: 'R15 Knokke - Neumarkt/Nürnberg',
    stations: [6308, 101375],
  },
  {
    id: 'route17',
    name: 'R16 Breda - Neubrandenburg',
    stations: [100089, 10280],
  },
  { id: 'route18', name: 'R17 Bouillon - Passau', stations: [6467, 103993] },
  {
    id: 'route19',
    name: 'R18 Warschau - Frankfurt/Main',
    stations: [12375, 103734],
  },
  { id: 'route20', name: 'R19 Groningen - Aue', stations: [100182, 103869] },
  { id: 'route21', name: 'R20 Andrezel - Dresden', stations: [104288, 10488] },
  {
    id: 'route22',
    name: 'R21 Roosendaal - Anklam',
    stations: [100293, 103366],
  },
  { id: 'route23', name: 'R22 Chimay - Salzburg', stations: [6455, 11150] },
  { id: 'route25', name: 'R23 Wien - Freiburg', stations: [11034, 104617] },
  { id: 'route26', name: 'R24 Le Mans – Zürich', stations: [7235, 6660] },
  { id: 'route27', name: 'R25 Prag - Freiburg', stations: [11518, 6628] },
  {
    id: 'route28',
    name: 'R26 Baden-Baden – Frederikshavn',
    stations: [105041, 6034],
  },
  {
    id: 'route29',
    name: 'R27 München - Frederikshavn',
    stations: [101628, 6034],
  },
];

export const dtgOfSelectedTimestep = (selectedTime: number, mapsTime) => {
  return moment(mapsTime).set('hour', selectedTime);
};

export const getSunTimes = (lat: number, lon: number, date: Moment): any => {
  const sunDate = date.toDate();
  const sunset = getSunset(lat, lon, sunDate);
  const sunrise = getSunrise(lat, lon, sunDate);
  return {
    sunrise: moment(sunrise).format('HH:mm'),
    sunset: moment(sunset).format('HH:mm'),
  };
};

export const hourClass = (
  hour: number,
  selectedTimeStep: number,
  stations: any[],
  stationTime: any
): string => {
  if (hour === selectedTimeStep) {
    return 'selected-hour';
  }
  if (isHourInRange(hour, stations, stationTime)) {
    return 'hour-in-range';
  }
  return '';
};

export const isHourInRange = (
  hour: number,
  stations: any[],
  stationTime: any
): boolean => {
  return hour >= stationTime[0] && hour <= stationTime[stations.length - 1];
};

export const indexClass = (
  stationIndex: number,
  stationId,
  parameter: string,
  hour,
  day: moment.Moment,
  showCurrent: boolean,
  matrixArray: any,
  mosData: any,
  stationTime: any,
  selectedTimeStep: number,
  selectedStationIndex: number,
  pigeonServiceDay: any,
  pigeonServiceMosData: any
): string => {
  // start with white background color
  let className = 'index99';
  const matrixKey = showCurrent ? 0 : day.toISOString();
  if (matrixArray.hasOwnProperty(stationId)) {
    if (matrixArray[stationId].hasOwnProperty(matrixKey)) {
      if (matrixArray[stationId][matrixKey].hasOwnProperty(hour.toString())) {
        className = matrixArray[stationId][matrixKey][hour.toString()];
      }
    }
  }
  if (className === 'index99') {
    // color
    const mosIndexValue = mosIndex(
      stationId,
      hour,
      day,
      showCurrent,
      pigeonServiceDay,
      pigeonServiceMosData
    );
    if (mosData.hasOwnProperty(stationId)) {
      if (mosData[stationId].hasOwnProperty(mosIndexValue)) {
        const dataset = mosData[stationId][mosIndexValue];
        const value = dataset[parameter];
        className = 'index' + value;
        if (!matrixArray.hasOwnProperty(stationId)) {
          matrixArray[stationId] = {};
          matrixArray[stationId][matrixKey] = {};
        }
        if (!matrixArray[stationId].hasOwnProperty(matrixKey)) {
          matrixArray[stationId][matrixKey] = {};
        }
        matrixArray[stationId][matrixKey][hour.toString()] = className;
      }
    }
  }
  // highlight column
  className +=
    ' highlightColumn' + (hour === stationTime[stationIndex] ? '1' : '0');
  // highlight line
  className += hour === stationTime[stationIndex] ? ' highlight-line' : '';
  // className += stationId === this.selectedStation() ? ' highlight-line' : '';
  // highlight table cell
  if (hour === selectedTimeStep && stationIndex === selectedStationIndex) {
    className += ' highlightCell';
  }
  return className;
};

export const mosIndex = (
  stationId: number,
  hour: number,
  day: Moment,
  showCurrent = false,
  pigeonServiceDay: any,
  pigeonServiceMosData: any
): any => {
  const dtg =
    showCurrent || pigeonServiceDay === null
      ? moment().set({
          hour: hour,
          minute: 0,
          second: 0,
        })
      : moment(day).set('hour', hour);
  if (pigeonServiceMosData.hasOwnProperty(stationId)) {
    for (const index of Object.keys(pigeonServiceMosData[stationId])) {
      const runDtg = moment(pigeonServiceMosData[stationId][index]['dtg']);
      if (runDtg.isSame(dtg, 'hour')) {
        return index;
      }
    }
  }
  return 0;
};

export const isPopupVisible = (hour, stationId, popupVisible): boolean => {
  return popupVisible.hasOwnProperty(hour) && popupVisible[hour] === stationId;
};

export const colorMapping = (parameter: string, value: number): string => {
  const colors = {
    0: '#a7f697',
    1: '#fef4a3',
    2: '#ff9900',
    3: '#ff0000',
    4: '#d900ff',
  };
  if (colors.hasOwnProperty(value)) {
    return colors[value];
  }
  return 'transparent';
};

export const pigeonColor = (
  parameter: string,
  stationId: number,
  pigeonMos,
  dtgs,
  dtgIndex: number,
  indexOfHours: number,
  endHour: number,
  startHour: number,
  day: Moment,
  pigeonMosData: any
): string => {
  let color = 'transparent';
  if (indexOfHours < 0 || indexOfHours > endHour - startHour) {
    color = 'rgba(0, 0, 0, 0.5)';
  } else if (pigeonMos.hasOwnProperty(stationId) && dtgIndex !== undefined) {
    const hour = startHour + indexOfHours;
    const currentMosIndex = mosIndex(
      stationId,
      hour,
      day,
      false,
      day,
      pigeonMosData
    );

    if (
      pigeonMos[stationId] &&
      pigeonMos[stationId].hasOwnProperty(currentMosIndex)
    ) {
      const dataset = pigeonMos[stationId][currentMosIndex];
      if (dataset.hasOwnProperty(parameter)) {
        const value = dataset[parameter];
        color = colorMapping(parameter, value);
      } else if (parameter.indexOf('|') > 0) {
        const parameters = parameter.split('|');
        const value = Math.max(dataset[parameters[0]], dataset[parameters[1]]);
        color = colorMapping(parameter, value);
      }
    }
  }
  return color;
};
